export const SET_ALL_DAY = 'SET_ALL_DAY';
export const SET_IS_EDIT_BOOKING = 'SET_IS_EDIT_BOOKING';
export const SET_END_TIME = 'SET_END_TIME';
export const CLEAN_NEWBOOKING_DATA = 'CLEAN_NEWBOOKING_DATA';

export const SET_TYPE = 'SET_TYPE';

export const BOOKING_NEW_CLIENT_REQUEST = 'BOOKING_NEW_CLIENT_REQUEST';
export const FETCH_CLIENT_REQUEST = 'FETCH_CLIENT_REQUEST';
export const FETCH_CLIENT_SUCCESS = 'FETCH_CLIENT_SUCCESS';
export const FETCH_CLIENT_FAILURE = 'FETCH_CLIENT_FAILURE';

export const BOOKING_NEW_CLIENT_FAILURE = 'BOOKING_NEW_CLIENT_FAILURE';
export const BOOKING_PICK_CLIENT = 'BOOKING_PICK_CLIENT';

export const PICK_CATEGORY = 'PICK_CATEGORY';
export const UPDATE_NEWBOOKING_DATE = 'UPDATE_NEWBOOKING_DATE';
export const ADD_SERVICE_BOOKING = 'ADD_SERVICE_BOOKING';
export const UPDATE_SERVICE_BOOKING = 'UPDATE_SERVICE_BOOKING';
export const CREATE_APPOINTMENT_WITH_SERVICES_REQUEST = 'CREATE_APPOINTMENT_WITH_SERVICES_REQUEST';
export const CREATE_APPOINTMENT_WITH_SERVICES_SUCCESS = 'CREATE_APPOINTMENT_WITH_SERVICES_SUCCESS';
export const CREATE_APPOINTMENT_WITH_SERVICES_FAILURE = 'CREATE_APPOINTMENT_WITH_SERVICES_FAILURE';
export const FETCH_APPOINTMENT_FOR_EDIT_REQUEST = 'FETCH_APPOINTMENT_FOR_EDIT_REQUEST';
export const FETCH_APPOINTMENT_FOR_EDIT_SUCCESS = 'FETCH_APPOINTMENT_FOR_EDIT_SUCCESS';
export const FETCH_APPOINTMENT_FOR_EDIT_FAILURE = 'FETCH_APPOINTMENT_FOR_EDIT_FAILURE';
export const FETCH_EVENT_FOR_EDIT_REQUEST = 'FETCH_EVENT_FOR_EDIT_REQUEST';
export const FETCH_EVENT_FOR_EDIT_SUCCESS = 'FETCH_EVENT_FOR_EDIT_SUCCESS';
export const FETCH_EVENT_FOR_EDIT_FAILURE = 'FETCH_EVENT_FOR_EDIT_FAILURE';
export const UPDATE_APPOINTMENT_WITH_SERVICES_REQUEST = 'UPDATE_APPOINTMENT_WITH_SERVICES_REQUEST';
export const UPDATE_APPOINTMENT_WITH_SERVICES_SUCCESS = 'UPDATE_APPOINTMENT_WITH_SERVICES_SUCCESS';
export const UPDATE_APPOINTMENT_WITH_SERVICES_FAILURE = 'UPDATE_APPOINTMENT_WITH_SERVICES_FAILURE';
export const DELETE_APPOINTMENT_REQUEST = 'DELETE_APPOINTMENT_REQUEST';
export const DELETE_APPOINTMENT_SUCCESS = 'DELETE_APPOINTMENT_SUCCESS';
export const DELETE_APPOINTMENT_FAILURE = 'DELETE_APPOINTMENT_FAILURE';
export const CHANGE_APPOINTMENT_STATUS_REQUEST = 'CHANGE_APPOINTMENT_STATUS_REQUEST';
export const CHANGE_APPOINTMENT_STATUS_SUCCESS = 'CHANGE_APPOINTMENT_STATUS_SUCCESS';
export const CHANGE_APPOINTMENT_STATUS_FAILURE = 'CHANGE_APPOINTMENT_STATUS_FAILURE';
export const CLEAN_ALL_DATA = 'CLEAN_ALL_DATA';
export const BOOKING_UPDATE_CLIENT_REQUEST = 'BOOKING_UPDATE_CLIENT_REQUEST';
export const UPDATE_CLIENT_DATA = 'UPDATE_CLIENT_DATA';
export const BOOKING_UPDATE_CLIENT_FAILURE = 'BOOKING_UPDATE_CLIENT_FAILURE';
export const BOOKING_UPDATE_CLIENT_LIST_SUCCESS = 'BOOKING_UPDATE_CLIENT_LIST_SUCCESS';
export const EDIT_SERVICE_PRICE = 'EDIT_SERVICE_PRICE';
export const EDIT_SERVICE_PROCESSING = 'EDIT_SERVICE_PROCESSING';
export const EDIT_SERVICE_DURATION = 'EDIT_SERVICE_DURATION';
export const EDIT_SERVICE_CLIENT = 'EDIT_SERVICE_CLIENT';
export const REMOVE_ADDED_SERVICE = 'REMOVE_ADDED_SERVICE';
export const CLIENT_LAST_VISIT_REQUEST = 'CLIENT_LAST_VISIT_REQUEST';
export const CLIENT_LAST_VISIT_SUCCESS = 'CLIENT_LAST_VISIT_SUCCESS';
export const CLIENT_LAST_VISIT_FAILURE = 'CLIENT_LAST_VISIT_FAILURE';
export const EDIT_SERVICE = 'EDIT_SERVICE';

export const SET_CURRENT_STYLIST = 'SET_CURRENT_STYLIST';

export const CLIENT_LIST_REQUEST = 'CLIENT_LIST_REQUEST';
export const CLIENT_LIST_SUCCESS = 'CLIENT_LIST_SUCCESS';
export const CLIENT_LIST_FAILURE = 'CLIENT_LIST_FAILURE';

export const CREATE_DEPOSIT_IN_CHECKOUT = 'CREATE_DEPOSIT_IN_CHECKOUT';
export const CREATE_DEPOSIT_BACK_END_REQUEST = 'CREATE_DEPOSIT_BACK_END_REQUEST';
export const CREATE_DEPOSIT_BACK_END_SUCCESS = 'CREATE_DEPOSIT_BACK_END_SUCCESS';
export const CREATE_DEPOSIT_BACK_END_FAILURE = 'CREATE_DEPOSIT_BACK_END_FAILURE';

export const GET_CLIENT_DEPOSIT_DETAILS_REQUEST = 'GET_CLIENT_DEPOSIT_DETAILS_REQUEST';
export const GET_CLIENT_DEPOSIT_DETAILS_SUCCESS = 'GET_CLIENT_DEPOSIT_DETAILS_SUCCESS';
export const GET_CLIENT_DEPOSIT_DETAILS_FAILURE = 'GET_CLIENT_DEPOSIT_DETAILS_FAILURE';

export const CHANGE_BOOKING_NOTES = 'CHANGE_BOOKING_NOTES';

export const FREQUENTLY_LIST_REQUEST = 'FREQUENTLY_LIST_REQUEST';
export const FREQUENTLY_LIST_SUCCESS = 'FREQUENTLY_LIST_SUCCESS';
export const FREQUENTLY_LIST_FAILURE = 'FREQUENTLY_LIST_FAILURE';

export const GET_PREFERENCE_REQUEST = 'GET_PREFERENCE_REQUEST';
export const GET_PREFERENCE_SUCCESS = 'GET_PREFERENCE_SUCCESS';
export const GET_PREFERENCE_FAILURE = 'GET_PREFERENCE_FAILURE';
export const SET_REPEAT_RULE = 'SET_REPEAT_RULE';
export const SET_REPEAT_FOREVER = 'SET_REPEAT_FOREVER';

export const CHANGE_REPEAT_STATUS = 'CHANGE_REPEAT_STATUS';
export const CHANGE_REPEAT_FREQ = 'CHANGE_REPEAT_FREQ';
export const CHANGE_REPEAT_FREQTYPE = 'CHANGE_REPEAT_FREQTYPE';
export const CHANGE_REPEAT_UNTIL = 'CHANGE_REPEAT_UNTIL';
export const UPDATE_APPOINTMENT_WITH_REPEATING_SERVICES_REQUEST = 'UPDATE_APPOINTMENT_WITH_REPEATING_SERVICES_REQUEST';
export const UPDATE_APPOINTMENT_WITH_REPEATING_SERVICES_SUCCESS = 'UPDATE_APPOINTMENT_WITH_REPEATING_SERVICES_SUCCESS';
export const UPDATE_APPOINTMENT_WITH_REPEATING_SERVICES_FAILURE = 'UPDATE_APPOINTMENT_WITH_REPEATING_SERVICES_FAILURE';
export const EMPTY_APPOINTMENT_STATUS = 'EMPTY_APPOINTMENT_STATUS';
export const FETCH_APPOINTMENT_STARTTIME_REQUEST = 'FETCH_APPOINTMENT_STARTTIME_REQUEST';
export const FETCH_APPOINTMENT_STARTTIME_SUCCESS = 'FETCH_APPOINTMENT_STARTTIME_SUCCESS';
export const FETCH_APPOINTMENT_STARTTIME_FAILURE = 'FETCH_APPOINTMENT_STARTTIME_FAILURE';
export const CS_TEAM_REQUEST = 'CS_TEAM_REQUEST';
export const CS_TEAM_SUCCESS = 'CS_TEAM_SUCCESS';
export const CS_TEAM_FAILURE = 'CS_TEAM_FAILURE';

export const CLIENT_NO_SHOW_RATE_REQUEST = 'CLIENT_NO_SHOW_RATE_REQUEST';
export const CLIENT_NO_SHOW_RATE_SUCCESS = 'CLIENT_NO_SHOW_RATE_SUCCESS';
export const CLIENT_NO_SHOW_RATE_FAILURE = 'CLIENT_NO_SHOW_RATE_FAILURE';
export const SHOW_MORE_REPEAT_REQUEST = 'SHOW_MORE_REPEAT_REQUEST';
export const SHOW_MORE_REPEAT_SUCCESS = 'SHOW_MORE_REPEAT_SUCCESS';
export const SHOW_MORE_REPEAT_FAILURE = 'SHOW_MORE_REPEAT_FAILURE';
export const CLEAR_FUTURE_BOOKING_DATA = 'CLEAR_FUTURE_BOOKING_DATA';
export const CLEAR_DELETE_APPOINTMENT_INFO = 'CLEAR_DELETE_APPOINTMENT_INFO';
export const CLEAR_CHARGE_ERROR = 'CLEAR_CHARGE_ERROR';
export const REMOVE_NEW_APPOINTMENT = 'REMOVE_NEW_APPOINTMENT';
